"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = exports.InputField = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var clsx_1 = __importDefault(require("clsx"));
var O = __importStar(require("fp-ts/Option"));
var function_1 = require("fp-ts/function");
var React = __importStar(require("react"));
var propsFilter_1 = require("../../../../library/propsFilter");
var SharkMorphContext_1 = require("../../../../providers/SharkMorphContext");
var Icon_1 = require("../../../Icon");
var nameFieldsBuilder_1 = require("../../nameFieldsBuilder");
var fieldMaker_1 = require("../fieldMaker");
require("./input.css");
var InputField = /** @class */ (function (_super) {
    __extends(InputField, _super);
    function InputField(props) {
        var _this = _super.call(this, props) || this;
        _this.cursorState = { position: null, length: 0 };
        _this.InputRef = { input: React.createRef() };
        _this.onChange = function (e) {
            _this.cursorState = {
                position: e.target.selectionStart,
                length: e.target.value.length,
            };
            _this.props.onChange && _this.props.onChange(e.target.value, e.target.value);
        };
        _this.hasText = function () {
            return (0, function_1.pipe)(O.fromNullable(_this.InputRef.input.current), O.filter(function (el) { return el.value.length !== 0; }));
        };
        _this.createButtonIcon = function (icon) { return ((0, jsx_runtime_1.jsx)("button", __assign({ disabled: (0, function_1.pipe)(_this.hasText(), O.isNone), type: "submit", className: (0, clsx_1.default)("input-icon", "input-icon-button", "input-icon-".concat(icon.theme), "".concat((0, function_1.pipe)(_this.hasText(), O.map(function () { return 'input-icon-active'; }), O.toUndefined))), onClick: function (e) {
                if (icon.onClick) {
                    e.preventDefault();
                    return icon.onClick && icon.onClick();
                }
                return icon.onClick;
            } }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: icon.icon }) }))); };
        _this.createIcon = function (icon) { return ((0, jsx_runtime_1.jsx)("span", __assign({ className: (0, clsx_1.default)('input-icon', icon.onClick ? 'clickable' : null), onClick: icon.onClick }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: icon.icon, theme: icon.theme ? icon.theme : 'primary', size: icon.size }) }))); };
        _this.cursorState = __assign(__assign({}, _this.cursorState), { length: (0, function_1.pipe)(O.fromNullable(props.value), O.map(function (v) { return v.toString().length; }), O.getOrElse(function () { return 0; })) });
        return _this;
    }
    InputField.prototype.computateLentgh = function (value) {
        return (0, function_1.pipe)(O.fromNullable(value), O.map(function (v) { return v.toString().length; }), O.getOrElse(function () { return 0; }));
    };
    InputField.prototype.componentDidUpdate = function () {
        var index = this.cursorState.position;
        if (index && this.InputRef.input.current) {
            // a decorator can add or remove charts
            var position = index - (this.cursorState.length - this.computateLentgh(this.props.value));
            this.InputRef.input.current.setSelectionRange(position, position);
        }
    };
    InputField.prototype.renderButtonIcon = function () {
        var _this = this;
        return (0, function_1.pipe)(O.fromNullable(this.props.icon), O.map(function (icon) {
            switch (icon.type) {
                case 'button':
                    return _this.createButtonIcon(icon);
                case 'icon':
                    return _this.createIcon(icon);
            }
        }), O.toNullable);
    };
    InputField.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)("span", __assign({}, (0, propsFilter_1.getAllDataProps)(this.props, this.context), { className: (0, clsx_1.default)('input', "size-".concat(this.props.size), { disabled: this.props.disabled ? true : false }, this.props.icon ? 'input-container' : undefined, this.props.style && this.props.style === 'default' ? 'input-default' : undefined, this.props.className), css: (0, react_1.css)(this.props.customStyle) }, { children: [(0, jsx_runtime_1.jsx)("input", { type: this.props.type === 'password' ? this.props.type : 'text', maxLength: this.props.maxLength, value: (0, function_1.pipe)(O.fromNullable(this.props.value), O.getOrElse(function () { return ''; })), onChange: this.onChange, placeholder: this.props.placeholder, ref: this.props.forwardedRef || this.InputRef.input, name: (0, nameFieldsBuilder_1.buildFieldName)(this.props.name), onFocus: this.props.onFocus, onBlur: this.props.onBlur, disabled: this.props.disabled, id: this.props.id, role: this.props.role, autoComplete: this.props.autoComplete, autoFocus: this.props.autoFocus }), this.renderButtonIcon()] })));
    };
    InputField.contextType = SharkMorphContext_1.SharkMorphContext;
    return InputField;
}(React.PureComponent));
exports.InputField = InputField;
InputField.defaultProps = {
    size: 'std',
};
exports.Input = (0, fieldMaker_1.makeField)(InputField);
//# sourceMappingURL=Input.js.map